// Returns action creators for each create requisition action type
import {
    CLEAR_POST_PO_METADATA,
    DELETE_ALL_LINE_ITEM_ATTACHMENTS,
    DELETE_HEADER_ATTACHMENTS,
    DELETE_LINE_ATTACHMENTS,
    DELETE_REQ_LINE,
    DUPLICATE_LINE,
    SET_ADDRESS_EDITING,
    SET_ALL_LINES,
    SET_AMENDED_REQ,
    SET_ATTACHMENT_LINE_ITEM,
    SET_COPY_REQ,
    SET_CREATE_REQ_FORM_LOADING,
    SET_DIALOG_ATTACHMENTS,
    SET_HEADER_ATTACHMENT_RECIPIENTS,
    SET_HEADER_ATTACHMENTS,
    SET_HEADER_FIELD,
    SET_HEDGING_CHECK_PASSED,
    SET_HR_ORGS_LOADING,
    SET_IS_INTERNAL_REQ,
    SET_LINE,
    SET_LINE_ITEM_ATTACHMENT_RECIPIENTS,
    SET_LINE_ITEM_ATTACHMENTS,
    SET_PAGE_NUM,
    SET_POST_PO_REQ,
    SET_REQ_ATTACHMENT_FILES_DIALOG,
    SET_REQUESTER_FIELD,
    SET_REQUISITION,
    SET_SUBMIT_LOADING,
    SET_SUPPLIER_NAME,
    SET_SUPPLIER_SITE,
    SET_VALIDATED,
    SET_WHOLE_LINE,
    TOGGLE_REQ_LIST_API_REFRESH,
    UPDATE_POST_PO_METADATA,
} from "../actionTypes";

export const clearPostPOMetadata = () => {
    return { type: CLEAR_POST_PO_METADATA };
};

// Action creators for create requisition slice
export const duplicateLine = (index, isAmendedReq) => {
    return {
        type: DUPLICATE_LINE,
        payload: { index: index, isAmendedReq: isAmendedReq },
    };
};

export const setAllLines = (field, value) => {
    return { type: SET_ALL_LINES, payload: { field, value } };
};

export const setCopyReq = (copyReq) => {
    return { type: SET_COPY_REQ, payload: copyReq };
};

export const setAmendedReq = (amendedReq) => {
    return { type: SET_AMENDED_REQ, payload: amendedReq };
};

export const setPostPOReq = (isPostPoReq) => {
    return { type: SET_POST_PO_REQ, payload: isPostPoReq };
};

export const setHeaderField = (field, value) => {
    return { type: SET_HEADER_FIELD, payload: { field, value } };
};
export const setRequesterField = (field, value) => {
    return { type: SET_REQUESTER_FIELD, payload: { field, value } };
};

export const setLine = (index, field, value) => {
    return { type: SET_LINE, payload: { index, field, value } };
};

export const setPageNum = (pageNum) => {
    return { type: SET_PAGE_NUM, payload: pageNum };
};

export const setRequisition = (iBuyRequisition) => {
    return { type: SET_REQUISITION, payload: iBuyRequisition };
};

export const setSubmitLoading = (loading) => {
    return { type: SET_SUBMIT_LOADING, payload: loading };
};

export const setValidated = (validated) => {
    return { type: SET_VALIDATED, payload: validated };
};

export const setIsInternalReq = (isInternalReq) => {
    return { type: SET_IS_INTERNAL_REQ, payload: isInternalReq };
};

export const deleteRequisitionLine = (index) => {
    return { type: DELETE_REQ_LINE, payload: index };
};

export const setWholeLine = (index, newLine) => {
    return { type: SET_WHOLE_LINE, payload: { index, newLine } };
};

export const setSupplierName = (name) => {
    return { type: SET_SUPPLIER_NAME, payload: name };
};

export const setSupplierSite = (name) => {
    return { type: SET_SUPPLIER_SITE, payload: name };
};

export const setHrOrgsLoading = (isLoading) => {
    return { type: SET_HR_ORGS_LOADING, payload: isLoading };
};

export const toggleReqListAPIRefresh = () => {
    return { type: TOGGLE_REQ_LIST_API_REFRESH };
};

export const updatePostPOMetadata = (key, value) => {
    return { type: UPDATE_POST_PO_METADATA, payload: { key, value } };
};

export const setCreateReqFormLoading = (isLoading) => {
    return { type: SET_CREATE_REQ_FORM_LOADING, payload: isLoading };
};

export const setHedgingCheckPassed = (hasPassed) => {
    return { type: SET_HEDGING_CHECK_PASSED, payload: hasPassed };
};

export const openAttachmentsCopyDialog = (openAttFilesDialog) => {
    return {
        type: SET_REQ_ATTACHMENT_FILES_DIALOG,
        payload: openAttFilesDialog,
    };
};

export const attachmentLineItem = (attachType, index) => {
    return {
        type: SET_ATTACHMENT_LINE_ITEM,
        payload: { attachType: attachType, index: index },
    };
};

export const addAttachmentsToLineItem = (attachments, index) => {
    return {
        type: SET_LINE_ITEM_ATTACHMENTS,
        payload: { attachments: attachments, index: index },
    };
};

export const addAttachmentsToHeader = (attachments) => {
    return {
        type: SET_HEADER_ATTACHMENTS,
        payload: attachments,
    };
};

export const setAttachmentsToLineItem = (attachments, index) => {
    return {
        type: SET_LINE_ITEM_ATTACHMENTS,
        payload: { attachments: attachments, index: index },
    };
};

export const deleteAllLineItemAttachments = () => {
    return {
        type: DELETE_ALL_LINE_ITEM_ATTACHMENTS,
        payload: {},
    };
};
export const deleteLineItemAttachments = (attachmentIdsToDelete) => {
    return {
        type: DELETE_LINE_ATTACHMENTS,
        payload: attachmentIdsToDelete,
    };
};

export const deleteHeaderAttachments = (attachments, index) => {
    return {
        type: DELETE_HEADER_ATTACHMENTS,
        payload: { attachments, index },
    };
};
export const addRecipientsToHeaderAttachment = (attachmentId, recipients) => {
    return {
        type: SET_HEADER_ATTACHMENT_RECIPIENTS,
        payload: { attachmentId: attachmentId, recipients: recipients },
    };
};

export const addRecipientsToReqLineAttachment = (
    lineIndex,
    attachmentId,
    recipients
) => {
    return {
        type: SET_LINE_ITEM_ATTACHMENT_RECIPIENTS,
        payload: {
            lineIndex: lineIndex,
            attachmentId: attachmentId,
            recipients: recipients,
        },
    };
};
export const setDialogAttachments = (attachments) => {
    return {
        type: SET_DIALOG_ATTACHMENTS,
        payload: {
            attachments,
        },
    };
};

export const setShouldEnableAddressEditing = (shouldEnableAddressEditing) => {
    return {
        type: SET_ADDRESS_EDITING,
        payload: {
            shouldEnableAddressEditing,
        },
    };
};
